import { useTranslation } from "react-i18next";
import { TestimonialProps } from "../types/testimonials";

export const useTestimonialsData = () => {
    const { t } = useTranslation("testimonialsData");

    const TestimonialDataDownload: TestimonialProps[] = Array.from({ length: 6 }, (_, i) => ({
        index: i,
        quote: t(`download.${i}.quote`),
        name: t(`download.${i}.name`),
        role: t(`download.${i}.role`),
        avatar: ["/avatars/reza.png", "/avatars/sara.png", "/avatars/alex.png", "/avatars/jennifer.png", "/avatars/david.png", "/avatars/emma.png"][i],
        rating: [5, 4.5, 5, 4, 5, 4.5][i],
    }));

    const TestimonialDataWatch: TestimonialProps[] = Array.from({ length: 5 }, (_, i) => ({
        index: i,
        rating: [5, 3.5, 5, 4, 5][i],
        avatar: `/media/testimonials/user${i + 1}.jpg`,
        name: t(`watch.${i}.name`),
        role: t(`watch.${i}.role`),
        quote: t(`watch.${i}.quote`),
    }));

    const TestimonialDataRing: TestimonialProps[] = Array.from({ length: 3 }, (_, i) => ({
        index: i,
        rating: [5, 4.5, 5][i],
        avatar: `/media/testimonials/user${i + 6}.jpg`,
        name: t(`ring.${i}.name`),
        role: t(`ring.${i}.role`),
        quote: t(`ring.${i}.quote`),
    }));

    const TestimonialDataTracker: TestimonialProps[] = Array.from({ length: 3 }, (_, i) => ({
        index: i,
        rating: [4.5, 4, 5][i],
        avatar: `/media/testimonials/user${i + 9}.jpg`,
        name: t(`tracker.${i}.name`),
        role: t(`tracker.${i}.role`),
        quote: t(`tracker.${i}.quote`),
    }));

    const TestimonialDataBand: TestimonialProps[] = Array.from({ length: 3 }, (_, i) => ({
        index: i,
        rating: [5, 4, 4.5][i],
        avatar: `/media/testimonials/user${i + 12}.jpg`,
        name: t(`band.${i}.name`),
        role: t(`band.${i}.role`),
        quote: t(`band.${i}.quote`),
    }));

    return {
        TestimonialDataDownload,
        TestimonialDataWatch,
        TestimonialDataRing,
        TestimonialDataTracker,
        TestimonialDataBand,
    };
};
